
(function(){

/* ==========================================================================
   SADZBA DO BLOKU ("filled")

   CSS justify rozhadzuje prebytok výhradne do medzier medzi slovami, takže
   pri krátkom riadku vzniknú diery cez pol karty. Tu to robíme ako sadzač:
   prebytok najprv absorbuje PRESTRKANIE (letter-spacing) a až zvyšok idú
   medzery. Medzera tak nikdy nepresiahne ~2x normálnu.
   ========================================================================== */

var MAX_GAP   = 1.0;    /* max. prídavok do medzery, v násobkoch medzery */
var MAX_TRACK = 0.12;   /* strop prestrkania, v em */

function fill(p){
  var text = p.getAttribute('data-text'); if(!text) return;
  var W = p.clientWidth; if(!W) return;

  var cs = getComputedStyle(p);
  var fs = parseFloat(cs.fontSize) || 16;
  var baseTrack = parseFloat(cs.letterSpacing) || 0;

  var m = document.createElement('span');
  m.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:pre;visibility:hidden';
  m.style.fontFamily    = cs.fontFamily;
  m.style.fontSize      = cs.fontSize;
  m.style.fontWeight    = cs.fontWeight;
  m.style.textTransform = cs.textTransform;
  m.style.letterSpacing = baseTrack + 'px';
  document.body.appendChild(m);
  function w(s){ m.textContent = s; return m.getBoundingClientRect().width; }

  var spaceW = w(' ') || fs * 0.28;

  /* --- lámanie riadkov: vyvažovanie, nie greedy ---------------------------
     Greedy napchá prvé riadky doplna a na posledný nechá zvyšok — ten sa
     potom pri "filled" roztiahne do dier. Namiesto toho hľadáme rozdelenie,
     ktoré minimalizuje SÚČET ŠTVORCOV zvyšného miesta cez všetky riadky,
     takže sú všetky riadky rovnomerne plné a medzery malé.
     (zjednodušený Knuth-Plass, O(n^2) — pri ~25 slovách zanedbateľné)      */

  var words = text.split(/\s+/).filter(Boolean);
  var n = words.length;
  var cache = {};
  function segW(i, j){                       /* šírka slov i..j-1 */
    var k = i + ':' + j;
    if(cache[k] === undefined) cache[k] = w(words.slice(i, j).join(' '));
    return cache[k];
  }

  var INF = Infinity;
  var best = new Array(n + 1).fill(INF), nxt = new Array(n + 1).fill(-1);
  best[n] = 0;
  for(var i = n - 1; i >= 0; i--){
    for(var j = i + 1; j <= n; j++){
      var ww = segW(i, j);
      if(ww > W && j > i + 1) break;         /* dlhšie už nemá zmysel skúšať */
      var slack = Math.max(0, W - ww);
      var cost  = slack * slack + best[j];
      if(cost < best[i]){ best[i] = cost; nxt[i] = j; }
    }
  }

  var lines = [], at = 0;
  while(at < n && nxt[at] > at){ lines.push(words.slice(at, nxt[at])); at = nxt[at]; }
  if(at < n) lines.push(words.slice(at));    /* poistka */

  /* --- vykreslenie --- */
  p.textContent = '';
  lines.forEach(function(line){
    var natural = w(line.join(' '));
    var gaps    = line.length - 1;
    var chars   = line.join('').length;
    var slack   = W - natural;

    var track = 0;
    if(slack > 0 && chars > 0){
      var absorbable = slack - spaceW * MAX_GAP * gaps;   /* čo sa nezmestí do medzier */
      if(absorbable > 0) track = Math.min(absorbable / chars, fs * MAX_TRACK);
    }

    var el = document.createElement('span');
    el.className = 'ln' + (gaps === 0 ? ' ln--single' : '');
    el.style.letterSpacing = (baseTrack + track) + 'px';
    el.style.setProperty('--tr', (baseTrack + track) + 'px');
    line.forEach(function(word){
      var s = document.createElement('span'); s.textContent = word; el.appendChild(s);
    });
    p.appendChild(el);
  });

  m.remove();
}

function fillAll(){ document.querySelectorAll('.js-fill').forEach(fill); }

/* Zmenší kartu, kým sa nezmestí na dostupnú výšku. Zalomenie textu sa
   so šírkou mení, preto sa iteruje — pár kôl stačí na ustálenie. */
function fitCard(){
  var stage = document.querySelector('.invite-stage');
  var card  = document.querySelector('.invite');
  if(!stage || !card) return;

  card.style.removeProperty('--cw-fit');
  fillAll();

  /* Na mobile sa karta NEZMENŠUJE. Formulár tam leží pod kartou, takže
     dvojica spolu často presiahne výšku displeja — a zmenšovanie by jej
     kvôli tomu ubralo šírku, hoci šírky je práve najmenej. Namiesto toho
     sa stránka scrolluje. Hranica je tá istá ako v @media v CSS.
     (Pozor: inline --cw-fit z tohto skriptu prebíja hodnotu z media query,
     preto tu nestačí spoľahnúť sa na CSS.) */
  if(window.matchMedia('(max-width: 620px)').matches) return;

  var avail = stage.clientHeight;
  for(var i = 0; i < 5; i++){
    var h = card.offsetHeight;
    if(h <= avail) break;
    var next = Math.max(280, Math.floor(card.offsetWidth * (avail / h)) - 2);
    card.style.setProperty('--cw-fit', next + 'px');
    fillAll();
  }
}

requestAnimationFrame(fitCard);
window.addEventListener('load', fitCard);
if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitCard);

/* prepočítaj pri zmene šírky OKNA aj pri zmene výšky — šírka karty
   sa odvíja od výšky viewportu, takže zmena výšky mení aj zalomenie */
var t, lastW = window.innerWidth, lastH = window.innerHeight;
window.addEventListener('resize', function(){
  if(window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 40) return;
  lastW = window.innerWidth; lastH = window.innerHeight;
  clearTimeout(t); t = setTimeout(fitCard, 120);
});

/* ==========================================================================
   ODOSLANIE + HLÁSENIA

   Prehliadaču sme vypli vlastné bubliny (novalidate), takže si chyby
   hlásime sami — jednou vetou, ktorá povie, čo konkrétne chýba.
   ========================================================================== */

var form  = document.querySelector('.invite__foot');
var errEl = form.querySelector('.formerr');
var okEl  = form.querySelector('.formstatus');
var btn   = form.querySelector('.submit');

/* Stav odoslania nesie tlačidlo: 'idle' → 'sending' → 'sent'. Karta sa
   nemení, takže je to jediná spätná väzba, ktorú človek dostane — preto sa
   po chybe musí vrátiť späť na 'idle', inak by ostal visieť dojem, že sa
   odoslalo. Vzhľad rieši CSS, tu sa len prepína atribút. */
function setSubmitState(state){
  if(!btn) return;
  btn.setAttribute('data-state', state);
  btn.disabled = (state !== 'idle');
}
var email = form.querySelector('input[name="email"]');
var dial  = form.querySelector('.tel__code');
var phone = form.querySelector('.tel__num');
var cons  = form.querySelector('input[name="consent"]');

function problem(){
  if(!email.value.trim())    return [email, 'Vyplň e-mailovú adresu'];
  if(!email.checkValidity()) return [email, 'E-mail nemá správny tvar'];
  if(!phone.value.trim())    return [phone, 'Vyplň telefónne číslo'];
  if(!phone.checkValidity()) return [phone, 'Číslo píš bez predvoľby, tú si vyber vľavo'];
  if(!cons.checked)          return [cons,  'Bez súhlasu ťa nevieme zaregistrovať'];
  return null;
}

function showError(msg){
  errEl.textContent = msg;
  errEl.classList.add('is-on');
}
function clearError(){
  errEl.classList.remove('is-on');
  errEl.textContent = '';
}

[email, phone, dial, cons].forEach(function(el){
  el.addEventListener('input',  clearError);
  el.addEventListener('change', clearError);
});

form.addEventListener('submit', function(e){
  e.preventDefault();
  form.classList.add('checked');

  var bad = problem();
  if(bad){
    showError(bad[1]);
    bad[0].focus();
    return;
  }
  clearError();

  setSubmitState('sending');
  saveContact(function(){
    setSubmitState('sent');
    /* Vizuálne potvrdenie je len farba a fajka — čítačka obrazovky
       potrebuje vetu. */
    if(okEl) okEl.textContent = 'Registrácia bola odoslaná.';
  });
});


/* ==========================================================================
   COOKIE BANNER

   Shopify vkladá súhlas s cookies ako fixný pruh pri spodnej hrane a ten
   na prvej návšteve prekryje tlačidlo aj checkbox — čiže presne to, na čo
   človek prišiel. Kým je banner na obrazovke, pridáme scéne spodné
   odsadenie a karta sa oň prispôsobí. Po zatvorení sa odsadenie zruší.
   ========================================================================== */

var bannerWatched = null;

function avoidConsentBanner(){
  var stage  = document.querySelector('.invite-stage');
  var banner = document.getElementById('shopify-pc__banner');
  if(!stage) return;

  /* Pozor: banner je position:fixed, takže offsetParent je pri ňom VŽDY
     null — na test viditeľnosti sa použiť nedá. Ideme cez skutočnú výšku
     a computed style. */
  var h = 0;
  if(banner){
    var r  = banner.getBoundingClientRect();
    var cs = getComputedStyle(banner);
    if(r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0'){
      h = Math.round(r.height);
    }
    /* keď banner nájdeme, sledujeme aj jeho vlastné zmeny —
       po odkliknutí sa nemusí odstrániť, len skryť */
    if(banner !== bannerWatched && window.MutationObserver){
      bannerWatched = banner;
      new MutationObserver(avoidConsentBanner)
        .observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
  }

  var want = h ? (h + 20) + 'px' : '';
  if(stage.style.paddingBottom !== want){
    stage.style.paddingBottom = want;
    fitCard();
  }
}

/* Banner sa vkladá aj ruší asynchrónne, preto sledujeme zmeny v <body>. */
avoidConsentBanner();
if(window.MutationObserver){
  new MutationObserver(avoidConsentBanner)
    .observe(document.body, { childList: true, subtree: true });
}
[200, 600, 1200, 2500, 4000].forEach(function(ms){ setTimeout(avoidConsentBanner, ms); });
window.addEventListener('resize', avoidConsentBanner);

/* ==========================================================================
   ULOŽENIE KONTAKTU

   Omnisend je na tomto obchode nainštalovaný ako Shopify Web Pixel v režime
   STRICT — beží v sandboxe a na stránke NEVYSTAVUJE window.omnisend. Volať
   ho priamo z formulára sa teda nedá.

   Ich REST API (POST https://api.omnisend.com/api/contacts) vie zapísať
   kontakt aj so súhlasom pre e-mail aj SMS, ale vyžaduje API kľúč — ten
   nesmie ísť do prehliadača. Preto sa volá cez vlastný endpoint, ktorý
   kľúč drží na serveri.

   FW27_ENDPOINT nastav na adresu toho endpointu. Kým je prázdny, formulár
   sa tvári funkčne, ale kontakt NIKAM neuloží — slúži len na preklikanie
   dizajnu.
   ========================================================================== */

var FW27_ENDPOINT = 'https://shimmi-fw27.filipphegedus.workers.dev/';

/* Endpoint chce telefón v E.164: +421901123456, bez medzier.

   Predvoľba ide z prepínača, do poľa sa píše len miestne číslo — takže sa
   nič neháda. Napriek tomu tu ostáva poistka pre človeka, ktorý si do poľa
   napriek placeholderu vloží celé medzinárodné číslo (typicky prekopírované
   z kontaktov): vtedy má prednosť to, čo napísal, a prepínač sa ignoruje.
   Bez toho by z +421901123456 vzniklo +421+421901123456.

   Úvodná nula miestneho čísla ide preč — 0901 je to isté číslo ako 901, ale
   s predvoľbou by z toho bolo +4210901…, čo neexistuje. */
function toE164(prefix, raw){
  var v = String(raw || '').replace(/[^0-9+]/g, '');

  if(v.charAt(0) === '+')   return v;
  if(v.indexOf('00') === 0) return '+' + v.slice(2);

  v = v.replace(/^0+/, '');
  if(!v) return '';

  return String(prefix || '') + v;
}

function saveContact(done){
  var payload = {
    email: email.value.trim(),
    phone: toE164(dial.value, phone.value),
    consent: cons.checked,
    source: 'fw27'
  };

  if(!FW27_ENDPOINT){
    console.warn('[fw27] FW27_ENDPOINT nie je nastavený — kontakt sa neuložil.', payload);
    done();
    return;
  }

  fetch(FW27_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(function(r){
    if(r.ok){ done(); return; }

    /* Endpoint posiela pri chybe aj `detail` s konkrétnou príčinou. Bez jeho
       vypísania ostane v konzole len "HTTP 502" a ladí sa naslepo — preto to
       telo dočítame a až potom hodíme chybu. */
    return r.text().then(function(telo){
      var detail = telo;
      try { var j = JSON.parse(telo); detail = j.detail || j.error || telo; } catch(e){}
      throw new Error('HTTP ' + r.status + ' — ' + detail);
    });
  }).catch(function(err){
    console.error('[fw27] uloženie zlyhalo:', err && err.message ? err.message : err);
    setSubmitState('idle');
    showError('Niečo sa pokazilo, skús to prosím znova');
  });
}

})();
